export const consoleDomains = ["root", "admin", "finance", "creator"] as const;

const consoleSessionStoragePrefix = "live178.admin.v2";

export type ConsoleDomain = (typeof consoleDomains)[number];

const loginRealms: Record<ConsoleDomain, string> = {
  root: "root.178live-internal.com",
  admin: "admin.178live.com",
  finance: "finance.178live.com",
  creator: "creator.178live.com",
};

const localAliases = new Set(["127.0.0.1", "localhost"]);

function pathDomain(pathname: string): ConsoleDomain | undefined {
  const segment = pathname.split("/").filter(Boolean)[0];
  return consoleDomains.find((domain) => domain === segment);
}

export function isLocalConsoleHostname(hostname: string) {
  return localAliases.has(hostname.toLowerCase());
}

export function resolveConsoleDomain(
  hostname: string,
  pathname: string,
): ConsoleDomain {
  const normalizedHost = hostname.toLowerCase();
  if (isLocalConsoleHostname(normalizedHost)) {
    return pathDomain(pathname) ?? "admin";
  }
  if (normalizedHost.startsWith("root.")) return "root";
  if (
    normalizedHost.startsWith("admin.") ||
    normalizedHost.startsWith("ops.")
  ) {
    return "admin";
  }
  if (normalizedHost.startsWith("finance.")) return "finance";
  if (normalizedHost.startsWith("creator.")) return "creator";
  return "admin";
}

export function resolveConsoleRouterBase(hostname: string, pathname: string) {
  const domain = pathDomain(pathname);
  return isLocalConsoleHostname(hostname) && domain ? `/${domain}/` : "/";
}

export function isLocalConsoleHost() {
  return isLocalConsoleHostname(window.location.hostname);
}

export function detectConsoleDomain(): ConsoleDomain {
  return resolveConsoleDomain(
    window.location.hostname,
    window.location.pathname,
  );
}

export function consoleRouterBase() {
  return resolveConsoleRouterBase(
    window.location.hostname,
    window.location.pathname,
  );
}

export function consoleStorageKey(name: string) {
  return `${consoleSessionStoragePrefix}.${detectConsoleDomain()}.${name}`;
}

export function consoleLoginRealm(domain = detectConsoleDomain()) {
  return loginRealms[domain];
}

export function adminDeviceFingerprint() {
  const key = "live178.admin.device";
  const current = localStorage.getItem(key)?.trim();
  if (current) return current;
  const created = crypto.randomUUID();
  localStorage.setItem(key, created);
  return created;
}
